/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import {
  PodSticker,
  PodSection,
  PodSpacer,
  ProductPod,
  ProductImage,
  ProductBadge,
  ProductRating
} from '@thd-olt-component-react/product-pod';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { Price } from '@thd-olt-component-react/price';
import { Favorite } from '@thd-olt-component-react/save-to-favorites';

export const FBTCustomProductPod = ({
  itemId, storeId, itemIndex, data, channel
}) => {
  return (
    <ProductPod
      itemId={itemId}
      storeId={storeId}
      analyticsData={{ parent: 'fbt-carousel', position: itemIndex }}
      render={(pod) => (
        <>
          <PodSticker position="top-left">
            <ProductBadge itemId={pod.itemId} storeId={storeId} />
          </PodSticker>
          <PodSticker position="top-right">
            <Favorite
              itemId={pod.itemId}
              storeId={storeId}
              showCircle
              showCount={false}
            />
          </PodSticker>
          <ProductImage
            itemId={pod.itemId}
            showSecondaryImage={pod.showSecondaryImage}
          />
          <PodSection columnAlign>
            <PodSpacer padding={['TOP', 'BOTTOM']}>
              <ProductHeader
                brand="above"
                itemId={pod.itemId}
                brandTitleMaxLine={3}
                disableShopThisCollection
              />
            </PodSpacer>
            <ProductRating itemId={pod.itemId} />
            <Price
              channel={channel}
              itemId={pod.itemId}
              large={false}
              product={data}
              showPreferredPricingBadge
              hideSavingsText={false}
            />
          </PodSection>
        </>
      )}
    />
  );
};

FBTCustomProductPod.dataModel = extend(
  ProductPod,
  ProductImage,
  ProductBadge,
  ProductRating,
  ProductHeader,
  Price,
  Favorite
);

FBTCustomProductPod.displayName = 'FBTCustomProductPod';